module.exports = __webpack_public_path__ + "img/img_xhpj1_ skill_brand@3x.4d880906.png";